// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/add-on-get-app-qrcode-slider/add-on-get-app-qrcode-slider.component.scss
// module id = 609
// module chunks = 0